import { isAnywhereUrl } from '@wix/wix-anywhere-api';
import { ControllerFlowAPI, IWixAPI } from '@wix/yoshi-flow-editor';
import { EXPERIMENTS } from '../constants';
import { toError } from './errors';

export async function isDayful(flowAPI: ControllerFlowAPI, wixCodeApi: IWixAPI) {
  try {
    const { baseUrl, url } = wixCodeApi.location;
    if (flowAPI.experiments.enabled(EXPERIMENTS.DAYFUL_SUPPORT) && baseUrl && url) {
      return await isAnywhereUrl({ externalBaseUrl: baseUrl, fullUrl: url });
    }
  } catch (e) {
    flowAPI.errorMonitor.captureException(toError(e));
  }
  return false;
}
